import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Music, Radio } from 'lucide-react';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gray-900 flex items-center justify-center px-6">
            <div className="text-center max-w-lg">
                <div className="text-8xl mb-6">🌊</div>

                <h1 className="text-9xl font-black gradient-text mb-2">404</h1>

                <h2 className="text-2xl font-bold text-white mb-4">
                    Lost in the wave
                </h2>

                <p className="text-gray-400 text-lg leading-relaxed mb-10">
                    This page doesn't exist or may have moved. Let's get you back to the music.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="/"
                        className="btn-primary flex items-center justify-center gap-2"
                    >
                        <Home className="w-4 h-4" />
                        Back to Home
                    </Link>
                    <Link
                        to="/feed"
                        className="btn-secondary flex items-center justify-center gap-2"
                    >
                        <Music className="w-4 h-4" />
                        Browse the Feed
                    </Link>
                </div>

                <p className="mt-10 text-gray-600 text-sm flex items-center justify-center gap-2">
                    <Radio className="w-4 h-4" />
                    The Deep Wave — South Florida Arts &amp; Sound
                </p>
            </div>
        </div>
    );
};

export default NotFound;
